import { createContext, ReactNode, useContext } from 'react';

import { useColorMode } from '../hooks/useColorMode';
import { ColorMode } from '../theme';

type ColorModeContextValue = {
  mode: ColorMode;
  toggle: () => void;
};

const ColorModeContext = createContext<ColorModeContextValue | null>(null);

export const ColorModeProvider = ({ children }: { children: ReactNode }) => {
  const { mode, toggle } = useColorMode();
  return (
    <ColorModeContext.Provider value={{ mode, toggle }}>
      {children}
    </ColorModeContext.Provider>
  );
};

export const useColorModeContext = (): ColorModeContextValue => {
  const ctx = useContext(ColorModeContext);
  if (!ctx) {
    throw new Error(
      'useColorModeContext must be used inside ColorModeProvider',
    );
  }
  return ctx;
};
